// 以下に app/frontend/js 配下のスクリプトをimportする
import { Application } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap';

// tom-select
import 'tom-select/dist/css/tom-select.bootstrap4.css';

// air-datepicker (祝日付き日付入力欄。見た目の調整は stylesheets/page/admin/_holiday_datepicker.scss)
import 'air-datepicker/air-datepicker.css';

//scss import
import '@/stylesheets/admin.scss';
import 'hint.css';

//js import

// AdminLTE
import 'admin-lte';
import 'admin-lte/dist/css/adminlte.min.css';
import 'admin-lte/dist/js/adminlte.min.js';

// ActionText
import "@rails/actiontext";
import "trix";
Trix.config.lang.urlPlaceholder = "https://www.example.com（https部分も入力してください）";

// Stimulus controllers import
import { CampaignTargetController } from './campaign-target-controller.js';
import { CancelPurchaseContractsController } from './cancel-purchase-contracts-controller.js';
import { CopyOperationPeriodController } from './copy-operation-period-controller.js';
import { CsvShiftjisSettingController } from './csv-shiftjis-setting-controller.js';
import { CustomerSearchController } from './customer-search-controller.js';
import { DirectUploadController } from './direct-uploader-controller.js';
import { ExportCsvController } from './export-csv-controller.js';
import { FormCheckboxController } from './form-checkbox-controller.js';
import { FormCheckboxSumController } from './form-checkbox-sum-controller.js';
import { ListRefreshController } from './list-refresh-controller.js';
import { FormTermController } from './form-term-controller.js';
import { HolidayDatepickerController } from './holiday-datepicker-controller.js';
import { IframeAutoheightController } from './iframe-autoheight-controller.js';
import { ImageFieldsController } from './image-fields-controller.js';
import { NftAccessController } from './nft-access-controller.js';
import { NotificationPreviewModalController } from './notification-preview-modal-controller.js';
import { PaidPurchaseContractsController } from './paid-purchase-contracts-controller.js';
import { SiteStatisticsController } from './site-statistics-controller.js';
import { ZenginController } from './zengin-controller.js';
import { RewardModalController } from './reward-modal-controller.js';
import { RowLinkController } from './row-link-controller.js';
import { RelayerBalanceModalController } from './relayer-balance-modal-controller.js';
import { TomSelectController } from './tom-select-controller.js';

// Start Stimulus application once
const application = Application.start();

// Register all controllers
application.register("direct-upload", DirectUploadController);
application.register("campaign-target", CampaignTargetController);
application.register("form-term", FormTermController);
application.register("cancel-purchase-contracts", CancelPurchaseContractsController);
application.register("copy-operation-period", CopyOperationPeriodController);
application.register("csv-shiftjis-setting", CsvShiftjisSettingController);
application.register("customer-search", CustomerSearchController);
application.register("export-csv", ExportCsvController);
application.register("form-checkbox", FormCheckboxController);
application.register("list-refresh", ListRefreshController);
application.register("form-checkbox-sum", FormCheckboxSumController);
application.register("holiday-datepicker", HolidayDatepickerController);
application.register("iframe-autoheight", IframeAutoheightController);
application.register("image-fields", ImageFieldsController);
application.register("nft-access", NftAccessController);
application.register("notification-preview-modal", NotificationPreviewModalController);
application.register("paid-purchase-contracts", PaidPurchaseContractsController);
application.register("site-statistics", SiteStatisticsController);
application.register("zengin", ZenginController);
application.register("reward-modal", RewardModalController);
application.register("row-link", RowLinkController);
application.register("relayer-balance-modal", RelayerBalanceModalController);
application.register("tom-select", TomSelectController);
